import { render, staticRenderFns } from "./submission-input.vue?vue&type=template&id=117339d6&scoped=true&"
import script from "./submission-input.vue?vue&type=script&lang=js&"
export * from "./submission-input.vue?vue&type=script&lang=js&"
import style0 from "./submission-input.vue?vue&type=style&index=0&id=117339d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117339d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VRow,VSpacer,VSwitch,VTextField,VTextarea})
